import { Divider, Stack, styled } from '@mui/material'
import {
  Message,
  IMessage,
  MessageSender,
  RawFileMessage,
  RawAudioMessage,
  RawVoiceMessage,
  RawImageMessage,
  RawVideoMessage,
} from '@weblite/ts-action/message'
import { getAvailableFunctions } from '$logic/message'
import { LinkPreviewer } from '$comp/_app/components/leftPanel/components/shared-media/components/link-previewer'
import { Audio } from './audio'
import { File } from './file'
import { Voice } from './voice'
import { Image } from './image'
import { Video } from './video'
import { DateWrapper } from '../date-wrapper'

const InsetDivider = styled(Divider)(({ theme }) => ({
  borderColor: theme.palette.veryLightGray,
  marginRight: '42px !important',
}))

export function MessageSelector({
  message,
  selected,
  selectOnTap,
  hideDivider,
  onSelectedChange,
  isOnLinkTab,
}: {
  message: Message
  selected: boolean
  selectOnTap: boolean
  hideDivider?: boolean
  onSelectedChange: (selectedValue: boolean) => void
  isOnLinkTab?: boolean
}) {
  const { type, sender, date, attachment } = message as IMessage

  if (type === 'EVENT' || type === 'WAPP') return null

  return (
    <Stack
      sx={{
        position: 'relative',
        overflow: 'hidden',
        width: '100%',
        height: '100%',
      }}
      onClick={e => {
        if (selected) {
          e.stopPropagation()
          onSelectedChange(false)
        } else if (selectOnTap) onSelectedChange(true)
      }}
      onContextMenu={e => {
        e.preventDefault()
        if (!selectOnTap) onSelectedChange(true)
      }}
    >
      {isOnLinkTab ? (
        <LinkPreviewer message={message as IMessage} selected={selected} />
      ) : type === 'FILE' ? (
        <DateWrapper date={date}>
          <File
            attachment={attachment as RawFileMessage['attachment']}
            selected={selected}
            selectOnTap={selectOnTap}
          />
        </DateWrapper>
      ) : type === 'AUDIO' ? (
        <DateWrapper date={date}>
          <Audio
            attachment={attachment as RawAudioMessage['attachment']}
            selected={selected}
            selectOnTap={selectOnTap}
            roomId={message.roomId}
            iid={message.iid}
          />
        </DateWrapper>
      ) : type === 'VOICE' ? (
        <DateWrapper date={date}>
          <Voice
            attachment={attachment as RawVoiceMessage['attachment']}
            sender={sender as MessageSender}
            selected={selected}
            selectOnTap={selectOnTap}
            roomId={message.roomId}
            iid={message.iid}
          />
        </DateWrapper>
      ) : type === 'IMAGE' ? (
        <Image
          attachment={attachment as RawImageMessage['attachment']}
          selected={selected}
          selectOnTap={selectOnTap}
          roomId={message.roomId}
          iid={message.iid}
        />
      ) : type === 'VIDEO' ? (
        <Video
          attachment={attachment as RawVideoMessage['attachment']}
          selected={selected}
          selectOnTap={selectOnTap}
          roomId={message.roomId}
          iid={message.iid}
        />
      ) : null}

      {!hideDivider && <InsetDivider variant="inset" />}
    </Stack>
  )
}

MessageSelector.defaultProps = {
  hideDivider: true,
  isOnLinkTab: false,
}
